import { IntegrationEmailAttachment } from '../../models/EmailAttachments'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface EmailAttachmentsState {
  emailThreadAttachments: IntegrationEmailAttachment[]
  isEmailThreadAttachmentsLoading: boolean
}

const initialState: EmailAttachmentsState = {
  emailThreadAttachments: [],
  isEmailThreadAttachmentsLoading: false,
}

export const emailAttachmentsSlice = createSlice({
  name: 'emailAttachments',
  initialState,
  reducers: {
    setEmailThreadAttachments: (state, action: PayloadAction<IntegrationEmailAttachment[]>) => {
      state.emailThreadAttachments = action.payload
    },
    setEmailThreadAttachmentsLoading: (state, action: PayloadAction<boolean>) => {
      state.isEmailThreadAttachmentsLoading = action.payload
    },
  },
})

export const { setEmailThreadAttachments, setEmailThreadAttachmentsLoading } = emailAttachmentsSlice.actions

export const selectEmailThreadAttachments = (state: RootState) => state.emailHub.emailAttachments.emailThreadAttachments
export const selectEmailThreadAttachmentsLoading = (state: RootState) => state.emailHub.emailAttachments.isEmailThreadAttachmentsLoading
